<template>
  <div>
    <div class="topbar py-1 d-none d-md-block">
      <BContainer>
        <div class="d-flex justify-content-end align-items-center pt-0">
          <router-link to="/contact" class="me-4"
            ><span
              ><img
                :src="contact"
                alt="contact"
                class="pe-1"
                style="height: 15px"
              />{{ $t("t-landing-menu-help") }}</span
            >
          </router-link>
          <a href="mailto:gebrauchtstapler@sander-ft.de" class="me-4">
            <span
              ><img
                :src="mail"
                alt="contact"
                class="pe-1"
                style="height: 13px"
              />gebrauchtstapler@sander-ft.de
            </span>
          </a>
          <a href="tel:+4937152338486" class="me-4">
            <span
              ><img
                :src="phone"
                alt="contact"
                class="pe-1"
                style="height: 15px"
              />+49 371 523 38 486</span
            >
          </a>
          <LanguageSwitcher class="ms-1" />
        </div>
      </BContainer>
    </div>

    <nav
      class="navbar navbar-expand-lg navbar-landing fixed-top py-3"
      id="navbar"
    >
      <BContainer>
        <router-link class="navbar-brand" to="/">
          <img
            src="@/assets/images/logo-dark.png"
            class="card-logo card-logo-dark"
            alt="logo dark"
            height="40"
          />
          <img
            src="@/assets/images/logo-light.png"
            class="card-logo card-logo-light"
            alt="logo light"
            height="60"
          />
        </router-link>
        <button
          class="navbar-toggler py-0 fs-20 text-body"
          type="button"
          v-b-toggle.navbarSupportedContent
        >
          <i class="mdi mdi-menu"></i>
        </button>

        <BCollapse class="navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto mt-2 mt-lg-0" id="navbar-example">
            <li class="nav-item">
              <BLink class="nav-link fs-14" :to="{ path: '/' }">{{
                $t("t-landing-menu-home")
              }}</BLink>
            </li>
            <li class="nav-item">
              <BLink class="nav-link fs-14" :to="{ path: '/products' }"
                ><button
                  type="button"
                  class="btn btn-outline-primary special-button"
                  :class="{
                    'bg-primary': isProductsActive,
                    'text-white': isProductsActive,
                    'special-button-active': isProductsActive,
                  }"
                >
                  {{ $t("t-landing-menu-products") }}
                </button></BLink
              >
            </li>
            <li class="nav-item">
              <BLink class="nav-link fs-14" :to="{ path: '/about' }">{{
                $t("t-landing-menu-about")
              }}</BLink>
            </li>
            <li class="nav-item">
              <BLink class="nav-link fs-14" :to="{ path: '/contact' }">{{
                $t("t-landing-menu-contact")
              }}</BLink>
            </li>
          </ul>
          <SearchBar />
          <div class="d-block d-md-none mt-3">
            <LanguageSwitcher />
          </div>
        </BCollapse>
      </BContainer>
    </nav>
  </div>
</template>

<script>
import SearchBar from "@/components/modules/SearchBar.vue";
import LanguageSwitcher from "@/components/modules/LanguageSwitcher.vue";
const contact = require("@/assets/images/sander/LMH_Icons_chat.png");
const mail = require("@/assets/images/sander/LMH_Icons_mail.png");
const phone = require("@/assets/images/sander/LMH_Icons_phone.png");

export default {
  name: "MachineDetails",
  components: {
    SearchBar,
    LanguageSwitcher,
  },
  data() {
    return {
      contact,
      mail,
      phone,
    };
  },
  computed: {
    isProductsActive() {
      return this.$route.path.startsWith("/products");
    },
  },
  async mounted() {
    //###########

    window.addEventListener("scroll", this.setActiveSection);
    let backtoTop = document.getElementById("back-to-top");

    if (backtoTop) {
      backtoTop = document.getElementById("back-to-top");
      window.onscroll = function () {
        if (
          document.body.scrollTop > 100 ||
          document.documentElement.scrollTop > 100
        ) {
          backtoTop.style.display = "block";
        } else {
          backtoTop.style.display = "none";
        }
      };
    }

    window.addEventListener("scroll", function (ev) {
      ev.preventDefault();
      var navbar = document.getElementById("navbar");
      if (navbar) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("is-sticky");
        } else {
          navbar.classList.remove("is-sticky");
        }
      }
    });
  },
};
</script>
<style>
.special-button-active {
  border-color: var(--primary) !important;
}

.special-button {
  margin-top: -8px;
  font-weight: 500;
  border-color: #212529;
  color: #212529;
}

.topbar {
  position: fixed;
  top: 0;
  background: #e6e6e6;
  color: #595959;
  width: 100%;
  height: 30px; /* Passe die Höhe an, je nach gewünschter Größe */
  z-index: 1030;
  font-size: 12px;
}

.topbar a {
  color: #595959;
}

.topbar a :hover {
  color: var(--primary);
}

#navbar {
  top: 30px; /* genau die Höhe des Topbars */
  width: 100%;
  z-index: 1040;
}

@media (max-width: 768px) {
  #navbar {
    top: 0px;
  }
  .navbar.fixed-top {
    position: static !important;
    top: 0 !important;
  }
}
</style>
